import { fetchEntities } from 'actions/entities'
import SchemaForm from 'components/forms/SchemaForm'
import billingSubscriptionSchema from 'forms/superuser/billingSubscriptionSchema'
import React from 'react'
import { connect } from 'react-redux'

class BillingSubscriptionForm extends React.Component {
  componentDidMount () {
    this.props.fetchPlans()
    this.props.fetchBillables()
  }

  render () {
    return <SchemaForm entityName='billingSubscription' {...this.props}/>
  }
}

const mapStateToProps = (state, ownProps) => ({
  uiSchema: billingSubscriptionSchema(state, ownProps),
  submitButton: true
})

const mapDispatchToProps = (dispatch) => ({
  fetchPlans: () => dispatch(fetchEntities('billingPlans')),
  fetchBillables: () => {
    dispatch(fetchEntities('offices'))
    dispatch(fetchEntities('employments'))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(BillingSubscriptionForm)
